import React from 'react';
import {
  ArrowLeftIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

interface PropertySummary {
  title: string;
  address?: string;
  location?: string;
}

interface PropertyActionBarProps {
  property: PropertySummary;
  hasTenancies: boolean;
  onBack: () => void;
  onSendBroadcast: () => void;
  className?: string;
}

const PropertyActionBar: React.FC<PropertyActionBarProps> = ({
  property,
  hasTenancies,
  onBack,
  onSendBroadcast,
  className = ''
}) => {
  // Logic to prevent duplicate address display
  const addressText = property.address || property.location || '';
  const showAddress =
    addressText &&
    property.title.toLowerCase().trim() !== addressText.toLowerCase().trim();

  return (
    <div
      className={`flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4 ${className}`}
    >
      <div className="flex items-start gap-4">
        <button
          onClick={onBack}
          className="mt-1 inline-flex items-center text-gray-500 hover:text-gray-900 transition-colors"
          aria-label="Back to properties"
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </button>

        <div>
          <h2 className="text-2xl font-bold text-gray-900 leading-tight">
            {property.title}
          </h2>
          {showAddress && (
            <p className="text-sm text-gray-500 mt-1 flex items-center gap-1">
              {addressText}
            </p>
          )}
        </div>
      </div>

      {hasTenancies && (
        <button
          onClick={onSendBroadcast}
          className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors"
        >
          <ChatBubbleLeftRightIcon className="w-5 h-5 mr-2 text-gray-400" />
          Message Tenants
        </button>
      )}
    </div>
  );
};

export default PropertyActionBar;
